document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.wp-tab').forEach(function(tab) {
        tab.addEventListener('click', function() {
            var target = this.getAttribute('data-tab');

            // toggle active tab
            document.querySelectorAll('.wp-tab').forEach(function(t) {
                t.classList.remove('active');
            });
            this.classList.add('active');

            // toggle active panel
            document.querySelectorAll('.wp-panel').forEach(function(p) {
                p.classList.remove('active');
            });
            document.querySelector('.wp-panel[data-panel="' + target + '"]').classList.add('active');
        });
    });

    (function() {
        var header = document.querySelector('.site-header'); // ← your header class
        if (!header) return;

        window.addEventListener('scroll', function() {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > 0) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
        }, {
            passive: true
        });
    })();


    document.querySelectorAll('.pd-desc p').forEach(p => {
        if (p.innerHTML.trim() === '&nbsp;' || p.textContent.trim() === '') {
            p.remove();
        }
    });

});